import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GenericResponse } from '../models/Common';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  protected basePath = environment.basePath;

  constructor(private swPush: SwPush, private http: HttpClient) {}

  public requestSubscription() {
    if (!this.swPush.isEnabled) {
      console.log('Notification is not enabled.');
      return;
    }

    this.swPush
      .requestSubscription({
        serverPublicKey:
          'BBzQyGJwg7fTCo_067cXUTrAv1tf89DsLJ7gKIXfqdoRlWW4dxMDFoH7fh4rJA_vchMJGF01SILroyphoTgmQeY',
      })
      .then((_) => {
        this.http
          .post<GenericResponse>(
            `${this.basePath}/v1/user/push_notification`,
            _.toJSON(),
            this.httpOptions,
          )
          .subscribe((data: GenericResponse) => {
            if (data.status_code == 200) {
              console.log(data);
            } else {
              console.error(data);
            }
          });
      })
      .catch((_) => console.log);
  }

  public unsubscribePush() {
    this.http
      .delete<any>(`${this.basePath}/v1/user/push_notification`, this.httpOptions)
      .subscribe((data: GenericResponse) => {
        if (data.status_code == 200) {
          this.swPush.unsubscribe();
          console.log(data);
        } else {
          console.error(data);
        }
      });
  }
}
